import { createAsyncThunk } from '@reduxjs/toolkit';
import GccApiForbiddenError from 'gcs-common/clients/gccApiClient/errors/GccApiForbiddenError';
import GccApiUnauthorizedError from 'gcs-common/clients/gccApiClient/errors/GccApiUnauthorizedError';
import { initGccApi } from 'gcs-common/slices/gccApiConnection/gccApiConnectionThunks';
import { getApiBaseUrl } from 'gcs-common/slices/theme/themeSelectors';
import { showFailureNotification } from '../notifications/ShowNotificationThunk';

export const initGccApiWeb = createAsyncThunk('initialization/initGccApiWeb', async (_, { dispatch, getState }) => {
  const apiBaseUrl = getApiBaseUrl(getState());

  // TODO unify this with openErrorDialogMiddleware
  // the only reason we have to pass a callback to initGccApi is because
  // previously we did not have a common way to open the error modal in web and mobile
  const onApiRequestError = (e: unknown) => {
    if (e instanceof GccApiForbiddenError) {
      dispatch(showFailureNotification('Zugriff nicht erlaubt'));
    }
    if (e instanceof GccApiUnauthorizedError) {
      dispatch(showFailureNotification('Zugriff nicht erlaubt'));
    }
  };

  dispatch(
    // @ts-expect-error -> remove soon
    initGccApi({
      onRequestError: onApiRequestError,
      apiBaseUrl,
    }),
  );
});
